import axios from 'axios';

export const workflowThreeErrorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-three-error`,
    headers: {
        'Content-Type': 'application/json'
    }
})